module.exports = __webpack_public_path__ + "img/2024-ford-mustang-e.8d1077af.png";